<div class="equalizer-chart w-100 h-100">
	<canvas id="equalizerCanvas"></canvas>
</div>